import { TickerCell } from './TickerCell';
import { TickerSeparator } from './TickerSeparator';
import { useTicker } from '../../hooks/useTicker';

import classes from './Ticker.module.css';

export const Ticker = ({ futureDate, dateLabel }) => {
    const { days, hours, minutes, seconds, isTimeUp } = useTicker(futureDate);

	if(isTimeUp) {
		return (
			<span></span>
		);
	}

    return (
        <div className={classes.tickerShell}>
			<span className={classes.tickerText}><span className={"glyphicon glyphicon-time"}></span>SHIPS {dateLabel} if ordered in the next:</span>
            <TickerCell value={days} label="Days" visible={days > 0} />
            <TickerSeparator visible={days > 0} />
            <TickerCell value={hours} label="Hours" visible={true} />
            <TickerSeparator visible={true} />
            <TickerCell value={minutes} label="Minutes" visible={true} />
            <TickerSeparator visible={false} />
            <TickerCell value={seconds} label="Seconds" visible={false} />
        </div>              
    );
}